module.exports = __webpack_public_path__ + "assets/83c9fd0c85dc937943f5cc91dce66b1f.jpg";